<template>
    <div>
        <a-drawer
            :title="$t('program.modify_task' /* 修改任务 */)"
            width="700"
            placement="right"
            :closable="true"
            :body-style="{ height: 'calc(100vh - 57px)', paddingBottom: '50px', overflow: 'auto' }"
            :visible="visible"
            @close="handleDrawerClose"
        >
            <!-- 解决不置顶问题 -->
            <a-form :style="{ height: visible ? 'auto' : '0' }" class="session-form" :form="form">
                <a-row :gutter="[10, 0]">
                    <!-- 基本信息 -->
                    <a-col span="24" class="mb10">
                        <h2 class="title-subtitle">{{ $t('program.basic_info' /* 基本信息 */) }}</h2>
                    </a-col>
                    <a-col :xs="24" :sm="12">
                        <!-- <a-form-item class="mb0" label="">
                        <a-input type="hidden" v-decorator="['customid']" />
                    </a-form-item> -->
                        <a-form-item class="mb10" :label="$t('program.batch_live_label_date' /* 日期 */)">
                            <a-select
                                :placeholder="$t('formConfig.please_select' /* 请选择 */) + $t('program.batch_live_label_date' /* 日期 */)"
                                v-decorator="['date_id', { rules: [{ required: true, message: $t('formConfig.please_select' /* 请选择 */) + $t('program.batch_live_label_date' /* 日期 */) }] }]"
                            >
                                <a-select-option v-for="item in dateList" :key="item.id" :value="item.id">
                                    {{ item.meeting_date }}
                                </a-select-option>
                            </a-select>
                        </a-form-item>
                    </a-col>
                    <a-col :xs="24" :sm="12">
                        <a-form-item class="mb10" :label="$t('program.batch_live_label_hall' /* 会场 */)">
                            <a-select
                                :placeholder="$t('formConfig.please_select' /* 请选择 */) + $t('program.batch_live_label_hall' /* 会场 */)"
                                v-decorator="['hall_id', { rules: [{ required: true, message: $t('formConfig.please_select' /* 请选择 */) + $t('program.batch_live_label_hall' /* 会场 */) }] }]"
                            >
                                <a-select-option v-for="item in hallList" :key="item.id" :value="item.id">
                                    {{ item.meeting_hall }}
                                </a-select-option>
                            </a-select>
                        </a-form-item>
                    </a-col>
                    <a-col :span="24">
                        <a-form-item class="mb10" :label="$t('program.session_name' /* Session */)">
                            <a-select
                                :placeholder="$t('formConfig.please_select' /* 请选择 */) + $t('program.session_name' /* Session */)"
                                v-decorator="['program_id', { rules: [{ required: true, message: $t('formConfig.please_select' /* 请选择 */) + $t('program.session_name' /* Session */) }] }]"
                            >
                                <a-select-option v-for="item in sessionList" :key="item.id" :value="item.id">
                                    {{ item.name }}
                                </a-select-option>
                            </a-select>
                        </a-form-item>
                    </a-col>
                    <a-col :span="24">
                        <a-form-item :label="$t('program.participation_form' /* 参会形式 */)">
                            <a-radio-group name="teaching_form" v-decorator="['teaching_form']">
                                <a-radio :value="1">{{ $t('program.recorded_broadcast' /* 录播 */) }}</a-radio>
                                <a-radio :value="2">{{ $t('program.online_connection' /* 线上连线 */) }}</a-radio>
                                <a-radio :value="3">{{ $t('program.on_site_participation' /* 现场参会 */) }}</a-radio>
                                <a-radio :value="0">{{ $t('program.unit' /* 单元 */) }}</a-radio>
                            </a-radio-group>
                        </a-form-item>
                    </a-col>
                    <!-- 讲题讲者信息 -->
                    <a-col span="24" class="mb10">
                        <h2 class="title-subtitle">{{ $t('program.topic_speaker_info' /* 讲题讲者信息 */) }}</h2>
                    </a-col>
                    <a-col span="24">
                        <a-form-item>
                            <a-button type="primary" @click="$refs.autherListDrawer.show()">{{ $t('program.query_author' /* 查询作者 */) }}</a-button>
                        </a-form-item>
                    </a-col>
                    <!-- 是否有劳务费 -->
                    <a-col span="24" class="mb10">
                        <h2 class="title-subtitle">{{ $t('program.service_fee' /* 劳务费 */) }}</h2>
                    </a-col>
                    <a-col :span="24">
                        <a-form-item class="mb10" :label="$t('program.has_service_fee' /* 是否有劳务费 */)">
                            <a-radio-group v-decorator="['is_servicefee']">
                                <a-radio :value="1">{{ $t('formConfig.yes' /* 是 */) }}</a-radio>
                                <a-radio :value="0">{{ $t('formConfig.no' /* 否 */) }}</a-radio>
                            </a-radio-group>
                        </a-form-item>
                    </a-col>
                    <a-col :xs="24" :sm="12">
                        <a-form-item class="mb10" v-show="form.getFieldValue('is_servicefee') == 1" :label="$t('program.currency' /* 币种 */)">
                            <a-select
                                :placeholder="$t('formConfig.please_select' /* 请选择 */) + $t('program.currency' /* 币种 */)"
                                v-decorator="['currency', { rules: [{ required: true, message: $t('formConfig.please_select' /* 请选择 */) + $t('program.currency' /* 币种 */) }] }]"
                            >
                                <a-select-option v-for="item in currencyList" :key="item.id" :value="item.id">
                                    {{ item.name }}
                                </a-select-option>
                            </a-select>
                        </a-form-item>
                    </a-col>
                    <a-col :xs="24" :sm="12">
                        <a-form-item class="mb10" v-show="form.getFieldValue('is_servicefee') == 1" :label="$t('program.service_fee_amount' /* 劳务费金额 */)">
                            <a-input-number
                                v-decorator="['servicefee', { rules: [{ required: true, message: $t('program.please_fill_service_fee_amount' /* 请填写劳务费金额 */) }] }]"
                                :placeholder="$t('program.please_fill_service_fee_amount' /* 请填写劳务费金额 */)"
                            ></a-input-number>
                        </a-form-item>
                    </a-col>
                    <!-- 角色任务 -->
                    <a-col span="24" class="mb10">
                        <h2 class="title-subtitle">{{ $t('program.role_task' /* 角色任务 */) }}</h2>
                    </a-col>
                    <a-col :span="24">
                        <a-form-item class="mb10">
                            <a-radio-group v-decorator="['role_task', { rules: [{ required: true, message: $t('formConfig.please_select' /* 请选择 */) + $t('program.role_task' /* 角色任务 */) }] }]">
                                <a-radio-button v-for="item in roleTaskList" :value="item.id" :key="item.id">{{ item['typename_' + $route.params.lang] }}</a-radio-button>
                            </a-radio-group>
                        </a-form-item>
                    </a-col>
                    <!-- 负责人 -->
                    <a-col span="24" class="mb10">
                        <h2 class="title-subtitle">{{ $t('program.person_in_charge' /* 负责人 */) }}</h2>
                    </a-col>
                </a-row>
            </a-form>
            <div
                class="t-r"
                :style="{
                    position: 'absolute',
                    right: 0,
                    bottom: 0,
                    height: '50px',
                    width: '100%',
                    borderTop: '1px solid #e9e9e9',
                    padding: '10px 16px',
                    background: '#fff',
                    textAlign: 'right',
                    zIndex: 99
                }"
            >
                <a-button type="default" @click="visible = false">{{ $t('web.cancel' /* 取消 */) }}</a-button>
                <a-button :loading="loading" :disabled="loading" class="ml10" type="primary" @click="handleSubmitEvent(0)">{{ $t('web.save' /* 保存 */) }}</a-button>
            </div>
        </a-drawer>
        <!-- 作者列表 -->
        <auther-list-drawer ref="autherListDrawer"></auther-list-drawer>
    </div>
</template>

<script>
import moment from 'moment';
import pick from 'lodash.pick';
import customForm from '@/components/custom-form.vue';
import autherListDrawer from './auther-list-drawer.vue';

const fields = [];
export default {
    name: 'ScheduleUpdateDrawer',
    components: { customForm, autherListDrawer },
    data() {
        return {
            visible: false,
            sessionList: [],
            dateList: [],
            hallList: [],
            currencyList: [],
            roleTaskList: [],
            loading: false,
            form: this.$form.createForm(this)
        };
    },
    computed: {},
    methods: {
        show(info) {
            this.visible = true;
            console.log('info==', info);
        },
        //关闭弹窗
        handleDrawerClose() {
            this.form.resetFields();
            this.visible = false;
        },
        // 表单请求接口
        handleSubmitEvent(continues) {
            this.form.validateFields((err, values) => {
                if (!err) {
                } else {
                    this.form.validateFieldsAndScroll();
                }
            });
        },
        // 页面初始化
        pageInit() {
            this.loading = true;
            Promise.all([this.$request.get({ url: 'getProgramDateList' }), this.$request.get({ url: 'getProgramHallList' })])
                .then(res => {
                    this.dateList = res[0].data;
                    this.hallList = res[1].data;
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    },
    created() {},
    mounted() {
        this.pageInit();
    }
};
</script>
<style lang='less' scoped>
.session-form {
    overflow: hidden;
    /deep/.ant-form-item-label {
        line-height: 2;
    }
}
.title-subtitle {
    font-weight: bold;
    line-height: 1;
    margin: 5px 0 0 0;
    padding: 0;
    border-left: 3px solid var(--theme-color);
    padding-left: 10px;
    font-size: 14px;
}
::v-deep .ant-input-number {
    width: 100%;
}
</style>